/** Initials-based avatars — no external portrait service in production */

function hashSeed(seed) {
  const s = String(seed ?? '0')
  let h = 0
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0
  }
  return h
}

export function getContactInitials(contact) {
  const name = contact?.name || contact?.system_name || '?'
  const parts = String(name).split(/[\s-]+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  return String(name).slice(0, 2).toUpperCase()
}

export function getAvatarBg(contact) {
  const h = hashSeed(contact?.id ?? contact?.name ?? '0')
  const colors = ['#0f3d8a', '#2563eb', '#059669', '#d97706', '#7c3aed', '#db2777']
  return colors[h % colors.length]
}

/** @deprecated use initials avatar in ChatAvatar */
export function getChatAvatarUrl() {
  return null
}
